import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import queryString from "query-string";

// Components
import Searchbar from "./utils/Searchbar";
import ProductList from "./ProductList";
import SuggestedProducts from "./SuggestedProducts";
import SortOptions from "./utils/sort-options/SortOptions";

// Utils
import { defaultSortOptions } from "../utils/sorting";
import { addImpression } from "../utils/google-analytics";

class SearchProducts extends Component {
	constructor(props) {
		super(props);

		const query = !!props.location ? queryString.parse(props.location.search) : {};
		const queryValue = !!query.q ? query.q : "";

		this.state = {
			q: queryValue
		};
	}

	componentWillReceiveProps(nextProps) {
		const prevQuery = !!this.props.location ? queryString.parse(this.props.location.search) : {};
		const prevQueryValue = !!prevQuery.q ? prevQuery.q : "";

		const nextQuery = !!nextProps.location ? queryString.parse(nextProps.location.search) : {};
		const nextQueryValue = !!nextQuery.q ? nextQuery.q : "";

		if (prevQueryValue !== nextQueryValue) {
			this.setState({
				q: nextQueryValue
			});
		}
	}

	render() {
		let pageTitle = "Search Results";

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (title !== "") title += " | ";
		title += pageTitle;

		// if (this.state.q !== '') {
		//     pageTitle += ': ' + this.state.q
		// }

		let helmet = (
			<Helmet>
				<title>{title}</title>
				<meta property="og:title" content={title} />
				<meta property="og:description" content={title} />
				<meta property="twitter:title" content={title} />
			</Helmet>
		);

		return (
			<div className="body_container">
				{helmet}

				<div className="pt2 product_collection">
					<main className="pt0 grow_wrapper category_section">
						<h1>{pageTitle}</h1>

						<SortOptions options={defaultSortOptions} />

						<div className="pt2">
							<Searchbar placeholder={"Search products"} component={ProductList} searchEndpoint={"product-search"} itemsIndex="products" q={this.state.q} params={{ max: 12 }} pushState={true} addImpression={addImpression} {...this.props} />
						</div>
					</main>
					<SuggestedProducts />
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo,
		sortValue: state.sort.value,
		sortDir: state.sort.dir
	};
};

export default connect(mapStateToProps)(SearchProducts);



// WEBPACK FOOTER //
// ./src/components/SearchProducts.js